import { Component, Inject, OnInit } from '@angular/core';
import { SUPPORTED_LANGUAGES } from '@nx-fe/services';
import { SspAuthorizationService } from 'sspservices/ssp-authorization.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ssp-header',
  templateUrl: './ssp-header.component.html',
  styleUrls: ['./ssp-header.component.scss'],
})
export class SSPHeaderComponent implements OnInit {
  constructor(
    @Inject('LOCALSTORAGE') private localStorage: Storage,
    private authService: SspAuthorizationService,
    public translate: TranslateService
  ) {}

  ngOnInit() {
    this.setDefaultLanguage();
  }

  public get supportedLanguage(): any {
    return SUPPORTED_LANGUAGES;
  }

  public translateLanguageTo = (param: any) => {
    const selectedLanguage = param.target.value;
    this.localStorage.setItem('lang', selectedLanguage);
    this.updateApplicationLanguage(selectedLanguage);
    window.location.reload();
  };

  private updateApplicationLanguage = (lang: string) => {
    this.translate.use(lang);
  };

  private setDefaultLanguage = () => {
    const language = this.localStorage.getItem('lang');
    if (!!language) {
      this.updateApplicationLanguage(language);
    }
  };

  public onLogout = () => {
    this.authService.logout();
  };
}
